// Оптимизация картинок: ресайз + WebP. Cloudinary — через трансформации,
// PSN CDN и прочие — через прокси wsrv.nl (Cloudflare CDN). q=80 ≈ визуально
// без потерь, но в разы легче оригинала.
export function optimizeImage(url: string | undefined, width?: number): string {
  if (!url) return '';
  if (url.includes('res.cloudinary.com') && url.includes('/upload/')) {
    const transforms = width ? `f_auto,q_auto,w_${width}` : 'f_auto,q_auto';
    return url.replace('/upload/', `/upload/${transforms}/`);
  }
  if (/^https?:\/\//.test(url) && !url.includes('placehold') && !url.includes('via.placeholder')) {
    const stripped = url.replace(/^https?:\/\//, '');
    const w = width || 400;
    return `https://wsrv.nl/?url=${encodeURIComponent(stripped)}&w=${w}&output=webp&q=80`;
  }
  return url;
}
